/* eslint-disable max-len */
export const DEFAULT_SUBJECT = 'This is Default Subject';
// eslint-disable-next-line max-len
export const DEFAULT_DESCRIPTION = `Your latest report from TAI Services is attached. If you have received a PDF file, the Adobe Reader will allow you to open, view and print the test results. After reviewing your report, if you have technical questions, call (800) 554-4127. Ask for Michael Johnson (mikej@taiservices.com) or Ray Bernstein (rayb@taiservices.com). We appreciate your business and look forward to being of service to your Company again.

Thank you for using TAI Services,
Inc.`;

export const DEFAULT_RE_INSPECTION_BODY = `The attached is a list of units due for re-inspection.

As always, please keep us aware of any changes going on that affect us so we can keep our records up-to-date.

FOR PRICING AND SCHEDULING PLEASE CONTACT OUR COORDINATORS BY CALLING 800.554.4127 OR EMAILING THEM:

Becky Gipson, Senior Coordinator       
beckyg@taiservices.com   

Karrie Alcazar, Coordinator             
karrie@taiservices.com   

Suzanne Thomason, Coordinator   
suzanne@taiservices.com   

Tina Hobbs, Coordinator         
thobbs@taiservices.com   

Trina Vincent, Office Manager                   
trina@taiservices.com   


You should receive a reply within 2 working days. If you have not, please give us a call.  After receiving your quote and contacting your customer, please give us a call to set up scheduling.

If you no longer want to receive these notifications, please advise one of the above coordinators.

Thank you so much - we appreciate your business!

TAI SERVICES, INC.
Phone   800.554.4127   *   770.763.5930
Fax   800.591.6860   *   770.763.5935
1000 Cobb Place Blvd. NW
Bldg. 300, Ste. 300
Kennesaw, GA 30144
www.taiservices.com`;
